import { useState } from 'react';
import { setAdminToken, setAdminUser } from '../utils/authUtils';
import { getApiBaseUrlWithoutPath } from '../../config/environment';

const useAdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async (loginData) => {
    try {
      setLoading(true);
      setError(null);

      const apiUrl = getApiBaseUrlWithoutPath();

      const response = await fetch(`${apiUrl}/api/auth/admin-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
      });

      const result = await response.json();
      
      if (result.success) {
        setAdminToken(result.token);
        setAdminUser(result.user);
        setError(null); // Clear any previous errors on success
        return result;
      } else {
        throw new Error(result.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return { login, loading, error, clearError };
};

export default useAdminLogin;
